import { SoundEffectCategory } from '@/models/gallery'

// Auto-generated sound effect categories from JSON files
export const soundEffectCategories: SoundEffectCategory[] = [
    // air category
    {
        name: "air",
        items: [
            {
                id: "air-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/air-2.mp3",
                prompt: "Whistling wind through a narrow canyon, echoing",
            },
            {
                id: "air-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/air-3.mp3",
                prompt: "Sudden rush of compressed air release, mechanical sound",
            },
            {
                id: "air-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/air-4.mp3",
                prompt: "Soft hum of an air conditioner, soothing background noise",
            },
            {
                id: "air-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/air-6.mp3",
                prompt: "Crisp sound of air transitioning from hot to cold",
            },
            {
                id: "air-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/air-7.mp3",
                prompt: "Natural wind blowing across an open field, serene",
            },
        ]
    },

    // aircraft category
    {
        name: "aircraft",
        items: [
            {
                id: "aircraft-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/aircraft-1.mp3",
                prompt: "Powerful jet takeoff roar, high-speed ascent",
            },
            {
                id: "aircraft-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/aircraft-2.mp3",
                prompt: "Fighter jet flyby, sonic boom effect",
            },
            {
                id: "aircraft-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/aircraft-4.mp3",
                prompt: "Ambient airplane cabin noise, soft chatter",
            },
            {
                id: "aircraft-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/aircraft-5.mp3",
                prompt: "Propeller plane cruising, rhythmic engine hum",
            },
            {
                id: "aircraft-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/aircraft-6.mp3",
                prompt: "Air traffic control announcement, clear and concise",
            },
            {
                id: "aircraft-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/aircraft-11.mp3",
                prompt: "Faint sound of aircraft engines in the distance",
            },
        ]
    },

    // alarm category
    {
        name: "alarm",
        items: [
            {
                id: "alarm-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/alarm-1.mp3",
                prompt: "Fire room emergency alarm: A loud, urgent siren signaling danger.",
            },
            {
                id: "alarm-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/alarm-2.mp3",
                prompt: "Chemical attack alarm: A series of sharp, alternating tones for urgency.",
            },
            {
                id: "alarm-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/alarm-4.mp3",
                prompt: "Flight deck warning alarm: A high-pitched, repetitive alert for pilots.",
            },
            {
                id: "alarm-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/alarm-6.mp3",
                prompt: "Flight deck warning alarm: A high-pitched, repetitive alert for pilots.",
            },
            {
                id: "alarm-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/alarm-8.mp3",
                prompt: "Collision alarm: A frantic, escalating beep to warn of impending impact.",
            },
            {
                id: "alarm-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/alarm-10.mp3",
                prompt: "General alarm: A continuous, piercing tone indicating an emergency.",
            }
        ]
    },

    // ambience category
    {
        name: "ambience",
        items: [
            {
                id: "ambience-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/ambience-1.mp3",
                prompt: "Wind howling through trees, creating a haunting atmosphere",
            },
            {
                id: "ambience-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/ambience-2.mp3",
                prompt: "Crickets singing in the dark, night cricket sounds",
            },
            {
                id: "ambience-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/ambience-4.mp3",
                prompt: "Cicadas chirping under a starry night sky, night ambience",
            },
            {
                id: "ambience-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/ambience-5.mp3",
                prompt: "Wind howling through trees, creating a haunting atmosphere",
            },
            {
                id: "ambience-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/ambience-9.mp3",
                prompt: "Creepy night sounds with distant howls and rustling, horror ambience",
            },
            {
                id: "ambience-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/ambience-11.mp3",
                prompt: "Distant street traffic mixed with rain and church bells, urban night ambience",
            },
        ]
    },

    // animal category
    {
        name: "animal",
        items: [
            {
                id: "animal-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/animal-1.mp3",
                prompt: "Zebra whinnying loudly, calling to its herd",
            },
            {
                id: "animal-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/animal-4.mp3",
                prompt: "Zebra neighing anxiously, noticing a predator nearby",
            },
        ]
    },

    // bell category
    {
        name: "bell",
        items: [
            {
                id: "bell-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bell-1.mp3",
                prompt: "Soft church bell chimes, serene atmosphere",
            },
            {
                id: "bell-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bell-2.mp3",
                prompt: "Loud train crossing bell, urgent warning",
            },
            {
                id: "bell-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bell-3.mp3",
                prompt: "Jingle of sleigh bells, festive and cheerful",
            },
            {
                id: "bell-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bell-4.mp3",
                prompt: "Deep cow bell ringing, rustic countryside",
            },
            {
                id: "bell-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bell-5.mp3",
                prompt: "Gentle sheep bell sound, pastoral setting",
            },
        ]
    },

    // boat category
    {
        name: "boat",
        items: [
            {
                id: "boat-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/boat-1.mp3",
                prompt: "Deep, resonant boat horn echoing across the water.",
            },
            {
                id: "boat-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/boat-2.mp3",
                prompt: "Gentle water gurgling as a paddle boat glides by.",
            },
            {
                id: "boat-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/boat-3.mp3",
                prompt: "Loud diesel motor revving, powering a large boat.",
            },
            {
                id: "boat-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/boat-5.mp3",
                prompt: "Sharp boat siren piercing through the calm river air.",
            },
            {
                id: "boat-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/boat-8.mp3",
                prompt: "Soft waves lapping against the hull of a boat at rest.",
            },
            {
                id: "boat-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/boat-9.mp3",
                prompt: "Whirring sound of a boat engine starting up.",
            },
        ]
    },

    // booms category
    {
        name: "booms",
        items: [
            {
                id: "booms-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/booms-2.mp3",
                prompt: "Medium blast: A moderate explosion with a deep rumble, reminiscent of a distant cannon.",
            },
            {
                id: "booms-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/booms-3.mp3",
                prompt: "Large blast: A powerful, resonating boom that shakes the ground, like a building explosion.",
            },
            {
                id: "booms-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/booms-7.mp3",
                prompt: "TNT blast: A deep, thunderous explosion that resonates through the air.",
            },
            {
                id: "booms-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/booms-8.mp3",
                prompt: "Nuclear blast: A massive, earth-shaking boom followed by a haunting silence.",
            },
            {
                id: "booms-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/booms-10.mp3",
                prompt: "Sonic boom: A sharp, cracking sound that breaks the sound barrier, like a jet flying overhead.",
            },
        ]
    },

    // bullet category
    {
        name: "bullet",
        items: [
            {
                id: "bullet-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bullet-2.mp3",
                prompt: "Gunfire echoing in a canyon, distant and reverberating",
            },
            {
                id: "bullet-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bullet-5.mp3",
                prompt: "Loud weapon discharge, powerful and explosive",
            },
            {
                id: "bullet-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bullet-9.mp3",
                prompt: "Car impact with a bullet, crunching metal and shattering glass",
            },
            {
                id: "bullet-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bullet-10.mp3",
                prompt: "Mechanical crack of a firearm being loaded, metallic and precise",
            },
            {
                id: "bullet-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/bullet-11.mp3",
                prompt: "Rapid succession of firearm shots, rhythmic and intense",
            },
        ]
    },

    // cartoon category
    {
        name: "cartoon",
        items: [
            {
                id: "cartoon-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-2.mp3",
                prompt: "Cartoon hearts beating, soft and rhythmic",
            },
            {
                id: "cartoon-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-3.mp3",
                prompt: "Comical cartoon fall, exaggerated thud",
            },
            {
                id: "cartoon-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-4.mp3",
                prompt: "Whimsical cartoon effects, magical and playful",
            },
            {
                id: "cartoon-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-5.mp3",
                prompt: "Cartoon doves cooing, gentle and sweet",
            },
            {
                id: "cartoon-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-6.mp3",
                prompt: "Bouncy cartoon cheer, joyful and energetic",
            },
            {
                id: "cartoon-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-7.mp3",
                prompt: "Surprised cartoon gasp, high-pitched and whimsical",
            },
            {
                id: "cartoon-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-9.mp3",
                prompt: "Playful cartoon jump sound, springy and light-hearted",
            },
            {
                id: "cartoon-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-10.mp3",
                prompt: "Cartoon scream, exaggerated and comical, echoing in a silly way",
            },
            {
                id: "cartoon-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/cartoon-11.mp3",
                prompt: "Whimsical cartoon music, cheerful melody with playful instruments",
            },
        ]
    },

    // communication category
    {
        name: "communication",
        items: [
            {
                id: "communication-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/communication-1.mp3",
                prompt: "Static interference, garbled radio signal",
            },
            {
                id: "communication-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/communication-3.mp3",
                prompt: "Cat meowing softly, echoing in a quiet room",
            },
            {
                id: "communication-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/communication-4.mp3",
                prompt: "Phone ringtone, cheerful and melodic",
            },
            {
                id: "communication-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/communication-5.mp3",
                prompt: "Urgent message alert, sharp and attention-grabbing",
            },
            {
                id: "communication-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/communication-9.mp3",
                prompt: "Phone notification ping, crisp and clear",
            },
            {
                id: "communication-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/communication-11.mp3",
                prompt: "Garbled voice transmission, unintelligible and distorted",
            },
        ]
    },

    // creature category
    {
        name: "creature",
        items: [
            {
                id: "creature-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/creature-2.mp3",
                prompt: "Eerie underwater creature sounds, bubbling and splashing.",
            },
            {
                id: "creature-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/creature-3.mp3",
                prompt: "Thunderous roar of a fantasy creature, shaking the ground.",
            },
            {
                id: "creature-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/creature-4.mp3",
                prompt: "High-pitched squeals of tiny creatures, scurrying in the grass.",
            },
            {
                id: "creature-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/creature-6.mp3",
                prompt: "Distressed creature screams, filled with pain and fear.",
            },
            {
                id: "creature-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/creature-7.mp3",
                prompt: "Mysterious aquatic creature sounds, gliding through the water.",
            },
            {
                id: "creature-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/creature-8.mp3",
                prompt: "Croaking of an amphibian creature, rhythmic and deep.",
            },
            {
                id: "creature-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/creature-11.mp3",
                prompt: "Epic battle roars of a game creature, fierce and powerful.",
            },
        ]
    },

    // crowd category
    {
        name: "crowd",
        items: [
            {
                id: "crowd-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-1.mp3",
                prompt: "Energetic crowd cheering, stadium atmosphere",
            },
            {
                id: "crowd-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-2.mp3",
                prompt: "Loud crowd applause, celebratory event",
            },
            {
                id: "crowd-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-3.mp3",
                prompt: "Chattering crowd in a bustling bar, lively ambiance",
            },
            {
                id: "crowd-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-4.mp3",
                prompt: "Angry crowd shouting, protest scene",
            },
            {
                id: "crowd-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-5.mp3",
                prompt: "Laughter from a joyful crowd, festive gathering",
            },
            {
                id: "crowd-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-7.mp3",
                prompt: "Crowd noise building up, anticipation before a performance",
            },
            {
                id: "crowd-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-8.mp3",
                prompt: "Excited crowd murmuring, pre-game excitement",
            },
            {
                id: "crowd-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-9.mp3",
                prompt: "Distant crowd cheering, outdoor festival",
            },
            {
                id: "crowd-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/crowd-11.mp3",
                prompt: "Soft background chatter of a crowded restaurant",
            },
        ]
    },

    // door category
    {
        name: "door",
        items: [
            {
                id: "door-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/door-2.mp3",
                prompt: "Heavy metal door slamming shut, dramatic effect",
            },
            {
                id: "door-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/door-3.mp3",
                prompt: "Slowly opening door, suspenseful tension",
            },
            {
                id: "door-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/door-5.mp3",
                prompt: "Loud knocking on a door, urgent call",
            },
            {
                id: "door-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/door-6.mp3",
                prompt: "Squeaky door hinge, unsettling sound",
            },
            {
                id: "door-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/door-9.mp3",
                prompt: "Metal door creaking open, industrial feel",
            },
        ]
    },

    // environment category
    {
        name: "environment",
        items: [
            {
                id: "environment-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-1.mp3",
                prompt: "Gentle rustling leaves in a serene forest, nature ambiance",
            },
            {
                id: "environment-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-2.mp3",
                prompt: "Chirping birds at dawn, peaceful outdoor setting",
            },
            {
                id: "environment-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-3.mp3",
                prompt: "Raindrops falling on a tin roof, cozy indoor sound",
            },
            {
                id: "environment-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-4.mp3",
                prompt: "Distant thunder rumbling, ominous storm approaching",
            },
            {
                id: "environment-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-5.mp3",
                prompt: "Urban street sounds: cars honking and people chatting",
            },
            {
                id: "environment-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-7.mp3",
                prompt: "Flowing river with soft splashes, tranquil water sound",
            },
            {
                id: "environment-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-8.mp3",
                prompt: "Howling wind through a canyon, eerie outdoor ambiance",
            },
            {
                id: "environment-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-9.mp3",
                prompt: "Crickets chirping at night, calm summer evening",
            },
            {
                id: "environment-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/environment-10.mp3",
                prompt: "Splashing water in a fountain, lively urban park",
            },
        ]
    },

    // fire category
    {
        name: "fire",
        items: [
            {
                id: "fire-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-1.mp3",
                prompt: "Fire sound",
            },
            {
                id: "fire-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-2.mp3",
                prompt: "Fire crackling",
            },
            {
                id: "fire-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-3.mp3",
                prompt: "Fire swooshing noise",
            },
            {
                id: "fire-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-4.mp3",
                prompt: "Cinematic fire whoosh",
            },
            {
                id: "fire-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-5.mp3",
                prompt: "Campfire crackling",
            },
            {
                id: "fire-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-6.mp3",
                prompt: "Blazing inferno",
            },
            {
                id: "fire-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-7.mp3",
                prompt: "Fire crackling",
            },
            {
                id: "fire-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-8.mp3",
                prompt: "Cinematic fire whoosh",
            },
            {
                id: "fire-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-9.mp3",
                prompt: "Blazing inferno",
            },
            {
                id: "fire-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/fire-11.mp3",
                prompt: "Fire sound",
            },
        ]
    },

    // footstep category
    {
        name: "footstep",
        items: [
            {
                id: "footstep-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/footstep-1.mp3",
                prompt: "Soft footsteps on fresh snow, winter ambiance",
            },
            {
                id: "footstep-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/footstep-3.mp3",
                prompt: "Crunching leaves underfoot, autumn forest",
            },
            {
                id: "footstep-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/footstep-7.mp3",
                prompt: "Running footsteps on dirt, chase scene",
            },
            {
                id: "footstep-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/footstep-9.mp3",
                prompt: "Soft footsteps on grass, peaceful park",
            },
            {
                id: "footstep-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/footstep-10.mp3",
                prompt: "Echoing footsteps in a long hallway, suspenseful",
            },
            {
                id: "footstep-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/footstep-11.mp3",
                prompt: "Heavy boots stomping on a textured surface, industrial sound",
            },
        ]
    },

    // game category
    {
        name: "game",
        items: [
            {
                id: "game-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/game-2.mp3",
                prompt: "Game start jingle: An upbeat, catchy tune signaling the beginning of an adventure.",
            },
            {
                id: "game-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/game-3.mp3",
                prompt: "Game bonus sound: A cheerful chime indicating a reward or power-up.",
            },
            {
                id: "game-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/game-5.mp3",
                prompt: "Game over: A somber, echoing tone that signifies the end of a game.",
            },
            {
                id: "game-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/game-8.mp3",
                prompt: "Drink sound: A refreshing gulp or slurp, perfect for in-game hydration moments.",
            },
            {
                id: "game-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/game-10.mp3",
                prompt: "Game music loop: A rhythmic, energetic melody that plays continuously during gameplay.",
            },
        ]
    },

    // horror category
    {
        name: "horror",
        items: [
            {
                id: "horror-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/horror-1.mp3",
                prompt: "Eerie whispering voices, echoing in the dark",
            },
            {
                id: "horror-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/horror-4.mp3",
                prompt: "Diabolical laugh, chilling and sinister",
            },
            {
                id: "horror-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/horror-8.mp3",
                prompt: "Distant crying, echoing through an empty house",
            },
            {
                id: "horror-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/horror-10.mp3",
                prompt: "Heavy breathing, filled with dread and tension",
            },
        ]
    },

    // human category
    {
        name: "human",
        items: [
            {
                id: "human-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/human-1.mp3",
                prompt: "Baby crying: A high-pitched, wailing sound expressing distress.",
            },
            {
                id: "human-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/human-2.mp3",
                prompt: "Baby laughing: A joyful, infectious giggle that warms the heart.",
            },
            {
                id: "human-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/human-4.mp3",
                prompt: "Breath: A deep inhalation followed by a slow, calming exhale.",
            },
            {
                id: "human-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/human-6.mp3",
                prompt: "Cough: A sudden, harsh sound made to clear the throat.",
            },
            {
                id: "human-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/human-9.mp3",
                prompt: "Giggling: A light, bubbly sound of laughter, often contagious.",
            },
            {
                id: "human-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/human-10.mp3",
                prompt: "Heavy breathing: A deep, labored sound indicating exertion or anxiety.",
            },
        ]
    },

    // machinery category
    {
        name: "machinery",
        items: [
            {
                id: "machinery-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/machinery-1.mp3",
                prompt: "Clanking gears of a vintage machine, rhythmic and mechanical.",
            },
            {
                id: "machinery-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/machinery-2.mp3",
                prompt: "The whirring sound of a printing press in action, busy and industrious.",
            },
            {
                id: "machinery-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/machinery-5.mp3",
                prompt: "A rapid-fire burst from a military firearm, intense and explosive.",
            },
            {
                id: "machinery-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/machinery-6.mp3",
                prompt: "The hum of a vending machine dispensing snacks, mechanical and smooth.",
            },
            {
                id: "machinery-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/machinery-7.mp3",
                prompt: "The grinding noise of a heavy machinery operation, deep and resonant.",
            },
            {
                id: "machinery-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/machinery-8.mp3",
                prompt: "The sound of a household blender whirring to life, energetic and vibrant.",
            },
            {
                id: "machinery-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/machinery-10.mp3",
                prompt: "The thud of a heavy weapon being loaded, ominous and foreboding.",
            },
        ]
    },

    // motor category
    {
        name: "motor",
        items: [
            {
                id: "motor-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/motor-1.mp3",
                prompt: "Revving engine roar, automotive excitement",
            },
            {
                id: "motor-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/motor-2.mp3",
                prompt: "Electric motor whirring, futuristic vibe",
            },
            {
                id: "motor-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/motor-3.mp3",
                prompt: "Train chugging along tracks, rhythmic clatter",
            },
            {
                id: "motor-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/motor-4.mp3",
                prompt: "Aircraft engine starting, powerful thrust",
            },
            {
                id: "motor-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/motor-6.mp3",
                prompt: "Industrial machinery grinding, heavy duty",
            },
            {
                id: "motor-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/motor-8.mp3",
                prompt: "Car tires screeching, sharp turn",
            },
            {
                id: "motor-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/motor-10.mp3",
                prompt: "Heavy machinery lifting, hydraulic power",
            },
        ]
    },

    // rope category
    {
        name: "rope",
        items: [
            {
                id: "rope-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/rope-1.mp3",
                prompt: "Creaking rope under tension, suspenseful atmosphere",
            },
            {
                id: "rope-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/rope-3.mp3",
                prompt: "Pulley operation with a rhythmic clanking sound",
            },
            {
                id: "rope-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/rope-6.mp3",
                prompt: "Old rope fraying, eerie whispering sound",
            },
            {
                id: "rope-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/rope-10.mp3",
                prompt: "Rope pulley in motion, smooth mechanical whir",
            },
            {
                id: "rope-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/rope-11.mp3",
                prompt: "Tensioned rope vibrating, low humming resonance",
            },
        ]
    },

    // sport category
    {
        name: "sport",
        items: [
            {
                id: "sport-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/sport-3.mp3",
                prompt: "Sharp whistle blow, signaling the start of a game",
            },
            {
                id: "sport-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/sport-9.mp3",
                prompt: "Whistle blow for a foul, sharp and commanding",
            },
            {
                id: "sport-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/sport-11.mp3",
                prompt: "Crowd roaring after a game-winning goal, electric atmosphere",
            },
        ]
    },

    // weapon category
    {
        name: "weapon",
        items: [
            {
                id: "weapon-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-1.mp3",
                prompt: "AK-47 single shot, sharp crack of gunfire",
            },
            {
                id: "weapon-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-2.mp3",
                prompt: "AK-47 burst fire, rapid succession of shots",
            },
            {
                id: "weapon-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-3.mp3",
                prompt: "AK-47 reload, metallic clink of parts",
            },
            {
                id: "weapon-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-5.mp3",
                prompt: "Antique musket reload, wooden ramrod sound",
            },
            {
                id: "weapon-7",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-7.mp3",
                prompt: "Cannon fire, deep rumble and blast",
            },
            {
                id: "weapon-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-8.mp3",
                prompt: "Artillery shell launch, whoosh followed by thunder",
            },
            {
                id: "weapon-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-9.mp3",
                prompt: "Tank cannon blast, powerful roar and shockwave",
            },
            {
                id: "weapon-10",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-10.mp3",
                prompt: "Pistol shot, crisp and clear bang",
            },
            {
                id: "weapon-11",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/weapon-11.mp3",
                prompt: "Shotgun blast, loud and explosive discharge",
            },
        ]
    },

    // whistle category
    {
        name: "whistle",
        items: [
            {
                id: "whistle-1",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-1.mp3",
                prompt: "Haunting whistle echoing through a dark forest, eerie ambiance",
            },
            {
                id: "whistle-2",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-2.mp3",
                prompt: "Bird whistle melody, cheerful and bright",
            },
            {
                id: "whistle-3",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-3.mp3",
                prompt: "Loud train whistle signaling departure, powerful and clear",
            },
            {
                id: "whistle-4",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-4.mp3",
                prompt: "Mysterious whistle from the dark realm, unsettling and ghostly",
            },
            {
                id: "whistle-5",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-5.mp3",
                prompt: "Short calling whistle, sharp and attention-grabbing",
            },
            {
                id: "whistle-6",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-6.mp3",
                prompt: "Cartoon-style whistle, playful and exaggerated",
            },
            {
                id: "whistle-8",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-8.mp3",
                prompt: "Harmonica whistle tune, bluesy and soulful",
            },
            {
                id: "whistle-9",
                audioSrc: "https://cdn.aibrush.co/docs/audio/models/elevenlabs-sound-effects/whistle-9.mp3",
                prompt: "Wolf whistle, flirtatious and playful",
            },
        ]
    }

]

// Export the categories
export default soundEffectCategories
